import View, { ViewType } from './View'

export declare interface EmployeeOptions {
  showAvatar: boolean
  showJobPosition: boolean
  showContractHours: boolean
  showPlannedHours: boolean
  showPlanningBalance: boolean
  showBankOfHours: boolean
  showRole: boolean
}

export declare interface ScheduleOptions {
  showCompactView: boolean
  showName: boolean
  showWorkplace: boolean
  showWorkArea: boolean
  showOvertime: boolean
  showBreaks: boolean
  showNotes: boolean
  showTimezone: boolean
}

export declare interface CoverageOptions {
  showCompactView: boolean
  showName: boolean
  showWorkplace: boolean
  showWorkArea: boolean
  showBreaks: boolean
  showNotes: boolean
  showOvertime: boolean
}

export declare interface OtherOptions {
  showBackupShifts: boolean
}

interface Props {
  viewType: ViewType
  employee?: EmployeeOptions
  schedule?: ScheduleOptions
  coverage?: CoverageOptions
  other?: OtherOptions
}

class ViewOptions {
  viewType: ViewType
  employee: EmployeeOptions
  schedule: ScheduleOptions
  coverage: CoverageOptions
  other: OtherOptions

  constructor({ viewType, employee, schedule, coverage, other }: Props) {
    this.viewType = viewType
    this.employee = {
      showAvatar: true,
      showJobPosition: true,
      showContractHours: true,
      showPlannedHours: true,
      showPlanningBalance: true,
      showBankOfHours: true,
      showRole: true,
      ...(employee || {}),
    }
    this.schedule = {
      showCompactView: false,
      showName: true,
      showWorkplace: true,
      showWorkArea: true,
      showBreaks: true,
      showNotes: true,
      showOvertime: true,
      showTimezone: true,
      ...(schedule || {}),
    }
    this.coverage = {
      showCompactView: false,
      showName: true,
      showWorkplace: false,
      showWorkArea: false,
      showBreaks: false,
      showNotes: false,
      showOvertime: false,
      ...(coverage || {}),
    }
    this.other = {
      showBackupShifts: true,
      ...(other || {}),
    }
  }

  static defaultForView(view: View): ViewOptions {
    const { viewType } = view
    return new ViewOptions({ viewType })
  }

  toggleEmployeeOption(option: keyof EmployeeOptions): void {
    this.employee[option] = !this.employee[option]
  }

  toggleScheduleOption(option: keyof ScheduleOptions): void {
    this.schedule[option] = !this.schedule[option]
  }

  toggleCoverageOption(option: keyof CoverageOptions): void {
    this.coverage[option] = !this.coverage[option]
  }

  toggleOtherOption(option: keyof OtherOptions): void {
    this.other[option] = !this.other[option]
  }

  resetAllOptions(): void {
    const defaults = new ViewOptions({ viewType: this.viewType })
    this.employee = defaults.employee
    this.schedule = defaults.schedule
    this.coverage = defaults.coverage
    this.other = defaults.other
  }
}

export default ViewOptions
